export interface PlatformDefinition {
  categories: string[];
  logo?: any;
}

export const platformsDefinitions: {[key: string]: PlatformDefinition} = {
  'General': {
    categories: ['General']
  },
  'Facebook': {
    categories: ['Meta Image', 'Meta Carousel', 'Meta Collection'],
    logo: require('ressources/images/logos/facebook-logo.png')
  },
  'Instagram': {
    categories: ['Meta Image', 'Meta Carousel', 'Meta Collection'],
    logo: require('ressources/images/logos/instagram-logo.png')
  },
  'Google Ads': {
    categories: ['Performance Max', 'Demand Gen', 'Display', 'Youtube'],
    logo: require('ressources/images/logos/google-ads-logo.png')
  }
};

export interface PlatformGroup {
  platformLabel: string;
  logos: any[];
}

export const platformGroups: PlatformGroup[] = [
  { platformLabel: 'Meta',            logos: [require('ressources/images/logos/facebook-logo.png'), require('ressources/images/logos/instagram-logo.png')] },
  { platformLabel: 'Performance Max', logos: [require('ressources/images/logos/google-ads-logo.png')] },
  { platformLabel: 'Demand Gen',      logos: [require('ressources/images/logos/google-ads-logo.png')] },
  { platformLabel: 'Display',         logos: [require('ressources/images/logos/google-ads-logo.png')] },
  { platformLabel: 'YouTube',         logos: [require('ressources/images/logos/google-ads-logo.png')] },
  { platformLabel: 'Pinterest',       logos: ['https://cdn-icons-png.flaticon.com/512/220/220214.png'] },
  { platformLabel: 'LinkedIn',        logos: ['https://cdn-icons-png.flaticon.com/512/3536/3536505.png'] },
  { platformLabel: 'TikTok',          logos: ['https://cdn-icons-png.flaticon.com/512/3046/3046121.png'] },
  { platformLabel: 'Snapchat',        logos: ['https://cdn-icons-png.flaticon.com/512/15713/15713438.png'] },
  { platformLabel: 'DV360',           logos: [require('ressources/images/logos/dv360.webp')] },
];

export interface AspectRatioOption {
  label: string;
  value: string;
}

export const categoriesToAspectRatios: {[key: string]: AspectRatioOption[]} = {
  'General': [
    { label: '1:1', value: '1:1' },
    { label: '16:9', value: '16:9' },
    { label: '9:16', value: '9:16' },
    { label: '4:3', value: '4:3' }
  ],
  'Performance Max': [
    { label: '1:1', value: '1:1' },
    { label: '1.91:1', value: '1.91:1' },
    { label: '4:5', value: '4:5' },
    // { label: '4:1', value: '4:1' }
  ],
  'Demand Gen': [
    { label: '1:1', value: '1:1' },
    { label: '1.91:1', value: '1.91:1' },
    { label: '4:5', value: '4:5' },
    { label: '9:16', value: '9:16' },
    // { label: '4:1', value: '4:1' }
  ],
  'Display': [
    { label: '1:1', value: '1:1' },
    { label: '1.91:1', value: '1.91:1' },
    { label: '9:16', value: '9:16' },
    // { label: '4:1', value: '4:1' }
  ],
  'Youtube': [
    { label: '16:9', value: '16:9' },
    { label: '9:16', value: '9:16' },
  ],
  'Meta Image': [
    { label: '1.91:1', value: '1.91:1' },
    { label: '1:1', value: '1:1' },
    { label: '9:16', value: '9:16' },
    { label: '4:5', value: '4:5' }
  ],
  'Meta Carousel': [
    { label: '1:1', value: '1:1' },
    { label: '9:16', value: '9:16' }
  ],
  'Meta Collection': [
    { label: '1.91:1', value: '1.91:1' },
    { label: '1:1', value: '1:1' },
    { label: '4:5', value: '4:5' }
  ]
};

export interface PlatformFormatCombo {
  key: string;
  label: string;
  platform: string;
  platformLabel: string;
  aspectRatio: string;
  margins: {
    top: number;
    left: number;
    right: number;
    bottom: number;
  };
  targetWidth?: number;
  targetHeight?: number;
}

export const platformFormatCombos: PlatformFormatCombo[] = [
  // Meta (Facebook + Instagram — identical formats)
  { key: 'meta-1.91:1', label: 'Feed Landscape', platform: 'Facebook', platformLabel: 'Meta', aspectRatio: '1.91:1', margins: { top: 8,  bottom: 18, left: 8, right: 8 } },
  { key: 'meta-1:1',    label: 'Feed Square',    platform: 'Facebook', platformLabel: 'Meta', aspectRatio: '1:1',    margins: { top: 8,  bottom: 18, left: 8, right: 8 } },
  { key: 'meta-4:5',    label: 'Feed Portrait',  platform: 'Facebook', platformLabel: 'Meta', aspectRatio: '4:5',    margins: { top: 8,  bottom: 18, left: 8, right: 8 } },
  { key: 'meta-9:16s',  label: 'Story',          platform: 'Facebook', platformLabel: 'Meta', aspectRatio: '9:16',   margins: { top: 14, bottom: 20, left: 6, right: 6 } },
  { key: 'meta-9:16r',  label: 'Reel',           platform: 'Facebook', platformLabel: 'Meta', aspectRatio: '9:16',   margins: { top: 14, bottom: 35, left: 6, right: 6 } },

  // Performance Max
  { key: 'pmax-1:1',    label: 'Square',    platform: 'Google Ads', platformLabel: 'Performance Max', aspectRatio: '1:1',    margins: { top: 10, bottom: 10, left: 10, right: 10 } },
  { key: 'pmax-1.91:1', label: 'Landscape', platform: 'Google Ads', platformLabel: 'Performance Max', aspectRatio: '1.91:1', margins: { top: 10, bottom: 10, left: 10, right: 10 } },
  { key: 'pmax-4:5',    label: 'Portrait',  platform: 'Google Ads', platformLabel: 'Performance Max', aspectRatio: '4:5',    margins: { top: 10, bottom: 10, left: 10, right: 10 } },

  // Demand Gen
  { key: 'demandgen-1:1',    label: 'Square',    platform: 'Google Ads', platformLabel: 'Demand Gen', aspectRatio: '1:1',    margins: { top: 10, bottom: 10, left: 10, right: 10 } },
  { key: 'demandgen-1.91:1', label: 'Landscape', platform: 'Google Ads', platformLabel: 'Demand Gen', aspectRatio: '1.91:1', margins: { top: 10, bottom: 10, left: 10, right: 10 } },
  { key: 'demandgen-4:5',    label: 'Portrait',  platform: 'Google Ads', platformLabel: 'Demand Gen', aspectRatio: '4:5',    margins: { top: 10, bottom: 10, left: 10, right: 10 } },
  { key: 'demandgen-9:16',   label: 'Vertical',  platform: 'Google Ads', platformLabel: 'Demand Gen', aspectRatio: '9:16',   margins: { top: 14, bottom: 20, left: 6,  right: 6  } },

  // Display
  { key: 'display-1:1',    label: 'Square',    platform: 'Google Ads', platformLabel: 'Display', aspectRatio: '1:1',    margins: { top: 10, bottom: 10, left: 10, right: 10 } },
  { key: 'display-1.91:1', label: 'Landscape', platform: 'Google Ads', platformLabel: 'Display', aspectRatio: '1.91:1', margins: { top: 10, bottom: 10, left: 10, right: 10 } },
  { key: 'display-9:16',   label: 'Vertical',  platform: 'Google Ads', platformLabel: 'Display', aspectRatio: '9:16',   margins: { top: 14, bottom: 20, left: 6,  right: 6  } },

  // YouTube
  { key: 'youtube-16:9', label: 'Landscape', platform: 'Google Ads', platformLabel: 'YouTube', aspectRatio: '16:9', margins: { top: 10, bottom: 25, left: 5, right: 5 } },
  { key: 'youtube-9:16', label: 'Shorts',    platform: 'Google Ads', platformLabel: 'YouTube', aspectRatio: '9:16', margins: { top: 14, bottom: 35, left: 5, right: 5 } },

  // Pinterest
  { key: 'pinterest-1:1',  label: 'Pin Square',   platform: 'Pinterest', platformLabel: 'Pinterest', aspectRatio: '1:1',   margins: { top: 8,  bottom: 18, left: 8,  right: 8  } },
  { key: 'pinterest-2:3',  label: 'Standard Pin',platform: 'Pinterest', platformLabel: 'Pinterest', aspectRatio: '2:3',  margins: { top: 8,  bottom: 18, left: 8,  right: 8  } },
  { key: 'pinterest-9:16', label: 'Idea Pin',    platform: 'Pinterest', platformLabel: 'Pinterest', aspectRatio: '9:16', margins: { top: 14, bottom: 20, left: 6,  right: 6  } },

  // LinkedIn
  { key: 'linkedin-1.91:1', label: 'Feed Landscape', platform: 'LinkedIn', platformLabel: 'LinkedIn', aspectRatio: '1.91:1', margins: { top: 10, bottom: 18, left: 8, right: 8 } },
  { key: 'linkedin-1:1',    label: 'Feed Square',    platform: 'LinkedIn', platformLabel: 'LinkedIn', aspectRatio: '1:1',    margins: { top: 10, bottom: 18, left: 8, right: 8 } },
  { key: 'linkedin-4:5',    label: 'Feed Portrait',  platform: 'LinkedIn', platformLabel: 'LinkedIn', aspectRatio: '4:5',    margins: { top: 10, bottom: 18, left: 8, right: 8 } },

  // TikTok
  { key: 'tiktok-9:16', label: 'In-Feed / Spark', platform: 'TikTok', platformLabel: 'TikTok', aspectRatio: '9:16', margins: { top: 14, bottom: 35, left: 6, right: 6 } },

  // Snapchat
  { key: 'snapchat-9:16', label: 'Snap Ad',   platform: 'Snapchat', platformLabel: 'Snapchat', aspectRatio: '9:16', margins: { top: 14, bottom: 25, left: 6, right: 6 } },

  // DV360
  { key: 'dv360-300x600',   label: 'Half Page',           platform: 'DV360', platformLabel: 'DV360', aspectRatio: '1:2',      margins: { top: 0, bottom: 0, left: 0, right: 0 }, targetWidth: 300,  targetHeight: 600 },
  { key: 'dv360-320x480',   label: 'Mobile Interstitial', platform: 'DV360', platformLabel: 'DV360', aspectRatio: '2:3',      margins: { top: 0, bottom: 0, left: 0, right: 0 }, targetWidth: 320,  targetHeight: 480 },
  { key: 'dv360-970x250',   label: 'Billboard',           platform: 'DV360', platformLabel: 'DV360', aspectRatio: '97:25',    margins: { top: 0, bottom: 0, left: 0, right: 0 }, targetWidth: 970,  targetHeight: 250 },
  { key: 'dv360-1200x627',  label: 'Native Landscape',    platform: 'DV360', platformLabel: 'DV360', aspectRatio: '1200:627', margins: { top: 0, bottom: 0, left: 0, right: 0 }, targetWidth: 1200, targetHeight: 627 },
  { key: 'dv360-627x627',   label: 'Native Square',       platform: 'DV360', platformLabel: 'DV360', aspectRatio: '1:1',      margins: { top: 0, bottom: 0, left: 0, right: 0 }, targetWidth: 627,  targetHeight: 627 },
];

// Map platformLabel -> first logo for use in ImageLabel overlays
export const platformLogoMap: Record<string, string> = Object.fromEntries(
  platformGroups.map(({ platformLabel, logos }) => [platformLabel, logos[0]])
);
